// This will implement all Lottie animations
// Read more about Lottie - https://airbnb.io/lottie/
// Read more about this implementation - https://airbnb.io/lottie/web/getting-started.html

import $ from 'jquery';
import lottie from 'lottie-web';

Drupal.behaviors.troaxLottieAnimation = {
  attach() {
    $('.lottie-animation')
      .once('lottie-animation')
      .each((index, element) => this.attachLottieAnimation(element));
  },

  attachLottieAnimation(element) {
    $(element).each((index, item) => {
      lottie.loadAnimation({
        container: item,
        render: 'svg',
        loop: true,
        autoplay: true,
        path: item.dataset.animationPath,
      });
    });
  },
};
